import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { Row, Col } from 'react-bootstrap'
import ExternalLinkButton from '../ExternalLinkButton'
import BrowserLinks from '../BrowserLinks'
import UpdateFlag from '../UpdateFlag'

function ExpandedItemHitRow({
  item,
  hit,
  text,
  mini,
  linkoutTxt,
  linkoutURL,
  children,
  dataClassLabels,
}) {
  if (!hit) hit = item.symbol
/*  if (!text) text = '(' + item.id + ')' */
  if (!text) text = item.id
  let G = ''
  if (item.genus)
    G = item.genus.charAt(0).match(/[A-Z]/)
      ? item.genus.charAt(0) + '.'
      : item.genus
  let spClr = item.species === 'melanogaster' ? '#aaa' : '#caa'

  let updateFlag
  if (item.update_status) updateFlag = <UpdateFlag item={item} />

/*         <span dangerouslySetInnerHTML={{ __html: text }} /> */

  return (
    <Row>
      <Col xs={12}>
        <div className="pull-right">
          <span className={item.data_type + ' badge'}>
            {dataClassLabels[item.data_type]}
          </span>
        </div>
        {children}
        <a
          className={'btn btn-default btn-xs hit ' + item.data_type}
          href={'/reports/' + item.id}
          dangerouslySetInnerHTML={{ __html: hit }}
        />
        {updateFlag}
        &emsp;
        <a href={'/reports/' + item.id} dangerouslySetInnerHTML={{ __html: text }} />
        &emsp;
        {item.genus && item.species && (
          <i
            title={item.genus + ' ' + item.species}
            style={{
              whiteSpace: 'nowrap',
              color: spClr,
              fontSize: 'initial',
            }}>
            {G} {item.species}
          </i>
        )}
        &emsp;
        {(item.location || (item.locations && item.locations.length > 0)) && (
          <BrowserLinks item={item} children={children} mini={mini} />
        )}
        &emsp;
        {linkoutTxt && (
          <ExternalLinkButton
            item={item}
            label={linkoutTxt}
            url={linkoutURL}
            children={children}
          />
        )}
      </Col>
    </Row>
  )
}

ExpandedItemHitRow.defaultProps = {
  //  browserlinks: false
}

ExpandedItemHitRow.propTypes = {
  text: PropTypes.string,
  children: PropTypes.object,
  item: PropTypes.object.isRequired,
  //  browserlinks: PropTypes.bool,
}

export default observer(ExpandedItemHitRow)
